import { atomWithReset } from 'jotai/utils';

import { DeleteFileModal } from './types';

export const deleteFileModalState = atomWithReset<DeleteFileModal>({
  isOpen: false,
  fileId: null,
  fileName: null,
});
